<app-internal-page [backRouterLink]="getBackRouterLink()">
    <div content fxLayout="column" fxLayoutGap="20px" fxLayoutGap.xs="15px">
        <span class="mat-title">Qual tipo de atendimento deseja fazer?</span>
        
        <ng-container *ngFor="let type of types; let i = index">
            <app-selectable-card [selected]="isSelected(type.id)" (click)="typeSelectChanged(i)">
                <app-icon-circle card-icon [faIcon]="getIconByTypeName(type.name)"></app-icon-circle>
                <span card-description>
                    {{getDescriptionByTypeName(type.name)}}
                </span>
            </app-selectable-card>
        </ng-container>

    </div>
</app-internal-page>
